export default __webpack_public_path__ + "static/media/abtVec.07a50588.png";